export function getCSRFToken(): string | undefined {
  const cookie = document.cookie
    .split(";")
    .find((cookie) => cookie.trim().startsWith("CSRF-TOKEN="));

  return cookie?.split("=")[1];
}
